import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY, IS_DEMO } from './config.js';

if (IS_DEMO) {
  console.info('[campstudio-hr] DEMO mode — auth bypassed, mock data. Set CAMP_HR_SUPABASE_* in .env for live data.');
}

// Schema is `hr` (see db/hr_schema.sql). Every query goes through RLS.
// In demo mode this client is never actually called (see src/lib/db.js).
export const supabase = createClient(SUPABASE_URL || 'http://localhost', SUPABASE_ANON_KEY || 'anon', {
  db: { schema: 'hr' },
  auth: { persistSession: true, autoRefreshToken: true },
});
